export default {"src":"/_next/static/media/truck-white.aa1ad816.svg","height":15,"width":22};